module.exports = __webpack_public_path__ + "static/media/rolls-royce-logo.01c9b676.svg";